<template>
    <div class="border-b border-gray-200"></div>
</template>
